export const hashFile = async (file: File): Promise<string> => {
    const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', await file.arrayBuffer()))
    return Array.from(digest, (byte) => byte.toString(16).padStart(2, '0')).join('')
}
